<div class="toggle">
    <div class="toggle__wrapper">
        <a href="{{block.data.toggle1Target}}" [ngClass]="{'toggle__link--active': setActive(block.data.toggle1Target)}" class="toggle__link" (click)="setState($event)">{{block.data.toggle1Text}}</a>
        <a href="{{block.data.toggle2Target}}" [ngClass]="{'toggle__link--active': setActive(block.data.toggle2Target)}" class="toggle__link" (click)="setState($event)">{{block.data.toggle2Text}}</a>
        <span  class="toggle__indicator"></span>
    </div>
</div>
